import styled from 'styled-components';
import { injectTypography } from '../../../../utils/injectTypography';
import { injectSpacing } from '../../../../api/spacing/injectSpacing';
import { injectHideScrollBar } from '../../../../utils/injectHideScrollBar';
export const optionCount = 4;
export const optionSize = 60;
export const optionOffset = optionSize * ((optionCount - 1) / 2);
export const StyledBarrelSelect = styled.ul `
  --option-count: ${optionCount};
  --option-size: ${optionSize}px;
  --option-offset: calc(var(--option-size) * ((var(--option-count) - 1) / 2));

  position: relative;
  z-index: 1;

  display: flex;
  flex-flow: column nowrap;
  box-sizing: border-box;

  height: calc(var(--option-size) * var(--option-count));
  margin: 0;
  padding: 0;
  overflow: auto;
  overscroll-behavior: contain;

  line-height: var(--option-size);

  list-style: none;
  scroll-snap-type: y mandatory;

  ${injectHideScrollBar}

  /* This fixes an incompability between Firefox and the other browsers when
   * using padding inside an overflow container:
   * https://github.com/w3c/csswg-drafts/issues/129
   * https://bugzilla.mozilla.org/show_bug.cgi?id=748518
   */
  &::before,
  &::after {
    display: block;
    flex-shrink: 0;
    height: var(--option-offset);

    content: '';
  }
`;
export const StyledOption = styled.li `
  ${(props) => injectTypography(props, 'copy1')}

  box-sizing: border-box;
  scroll-snap-align: center;

  min-width: var(--option-size);
  min-height: var(--option-size);
  padding-inline-start: var(${(props) => props.theme.responsive.spacing.s});
  padding-inline-end: var(${(props) => props.theme.responsive.spacing.s});

  color: #666;
  line-height: var(--option-size);

  cursor: pointer;

  &[aria-selected='true'] {
    color: #000;

    cursor: auto;
  }
`;
export const StyledBarrelSelectGroup = styled.div `
  --option-size: ${optionSize}px;

  position: relative;

  display: grid;
  grid-auto-flow: column;
  grid-template-rows: auto;
  justify-content: center;

  column-gap: var(${(props) => props.theme.responsive.spacing.s});

  &::before {
    position: absolute;
    top: calc(50% - var(--option-size) / 2);
    right: 0;
    left: 0;
    z-index: 0;

    display: block;
    width: 100%;
    height: var(--option-size);

    background-color: #f2f2f2;

    content: '';
  }

  ${injectSpacing('margin')}
`;
//# sourceMappingURL=BarrelSelect.styles.js.map